
// Used as the default by LocText.jsx

const strings = {
	chooserLockedPrefix: 'Free donation<span class="br"> </span>unlocked in',
	chooserLockedPrefixMobile: 'Free<br>donation<br>unlocked in',
	chooserLockedInfix: 'will fund your<span class="unbr"> </span>donation in',
	chooserLockedFabricSmall: 'will fund your<span class="br"> </span>donation in <span class="highlight">{mmss}</span>',
	chooserLockedTall: 'Watch to<br>unlock a free<br>donation',

	chooserReady: 'Free donation unlocked!<br>Pick a charity',
	chooserReadyShort: 'Pick a charity',
	chooserComplete: 'Thank you!',

	// End card
	thankYouExcl: 'Thank you!', // Only used by default custom-layout on social
	endCardSupporting: 'Supporting',
	endCardChooserPrompt: 'Choose a charity<span class="br"> </span>to make a free donation',
	endCardTotalPledge: 'We\'re raising <div class="donation-amount">{totalPledged}</div>',
	endCardDonationMade: '<div class="thankyou">Thank you</div>Donation<span class="br"> </span>made!',
	donationInfo: 'Donation Info',

	// social cards deprecated as of july 2023 
	socialDonationUnlocked: 'Donation Unlocked',
	socialChooseCharity: 'Choose the charity you\'d like to support:',
	socialTotalPledged: 'Together, we\'re raising <span class="donation-amount">{totalPledged}</span>',
	socialTotalRunning: 'Through this campaign we\'ve raised <span class="donation-amount">{ct}</span>',
	socialThankYou: 'Thank you!',
	socialDonationSent: 'Your donation has been sent to',

	yes: 'Yes',
	no: 'No',
	consentOK: 'Opt In',
	consentGiven: '<h3>Thank you!</h3>Visit {myGlLink} to learn more,<br>change your preferences, or opt out.',
	consentPrevGiven: 'Visit {myGlLink} to change your cookie preferences.',

	// TAPT unit
	treeCounterPostfix: 'TREES PLANTED BY THESE ADS',
	treesFunded: 'Funded by:',
	treesTagline: 'THIS AD<br/>PLANTS<br/>TREES',
	treesFindOutMore: 'FIND OUT MORE ➡',
	treesEndcardTagline: 'THANK YOU<br/>DONATION MADE',

	poweredBy: 'Powered by', // Displayed above new ident
	skip: 'Skip', // Skip button (eg during video)
	close: 'CLOSE', // Close button (eg on endcard)

	bannerExplain_leaderboard: 'Give a donation by watching an advert',
	bannerExplain_billboard: 'Give a donation<span class="br"> </span>by watching an advert',
	bannerExplain_vbnr: 'Donate a few seconds',
	bannerExplain_mpu: 'Donate by watching an advert',
	bannerExplain_stickyfooter: 'Donate by watching an advert',
};

export default strings;
